import React from 'react';
import { SxProps, Theme } from '@mui/material';
import * as MuiIcons from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';

interface ZoneIconProps {
  iconName?: string | null;
  color?: string;
  sx?: SxProps<Theme>;
}

const toPascalCase = (str: string): string => {
  return str
    .split(/[-_\s]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('')
    .replace(/^[a-z]/, char => char.toUpperCase());
};

export const ZoneIcon: React.FC<ZoneIconProps> = ({ iconName, color, sx }) => {
  if (!iconName) {
    return <HomeIcon sx={{ color, ...sx }} />;
  }

  let processedIconName = iconName.trim();
  
  // Only convert if it contains hyphens, underscores, or spaces
  if (/[-_\s]/.test(processedIconName)) {
    processedIconName = toPascalCase(processedIconName);
  }
  
  if (processedIconName.endsWith('Icon')) {
    processedIconName = processedIconName.slice(0, -4);
  }
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const IconComponent = (MuiIcons as any)[processedIconName];
  
  if (IconComponent) {
    return <IconComponent sx={{ color, ...sx }} />;
  }

  return <HomeIcon sx={{ color, ...sx }} />;
};
